// extracted by mini-css-extract-plugin
export default {"print":"style-module--print--ccf51","printDescription":"style-module--printDescription--5e58a"};